import React from 'react';
import { MessageCircle } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const WhatsAppButton = () => {
  const whatsappUrl = `https://wa.me/${companyInfo.whatsapp}?text=Hi%20AskTech%20Solutions%2C%20I%20would%20like%20to%20know%20more%20about%20your%20services.`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="Connect on WhatsApp"
    >
      <div className="relative">
        {/* Pulse animation */}
        <div className="absolute inset-0 bg-[#25D366] rounded-full animate-ping opacity-25"></div>
        
        {/* Main button */}
        <div className="relative w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg shadow-[#25D366]/30 hover:scale-110 transition-transform duration-300">
          <MessageCircle className="w-8 h-8 text-white" fill="white" />
        </div>
        
        {/* Tooltip */}
        <div className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-white text-black text-sm font-medium px-4 py-2 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none">
          Connect on WhatsApp
          <div className="absolute left-full top-1/2 -translate-y-1/2 border-8 border-transparent border-l-white"></div>
        </div>
      </div>
    </a>
  );
};

export default WhatsAppButton;
